import { styled } from "@mui/material/styles";
import { Tabs } from "@mui/material";

export const StyledTabs = styled(Tabs)(({ theme, size = "medium" }) => ({
}));
